import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom'
import Select from 'react-tailwindcss-select';
import Swal from 'sweetalert2';

import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import Input from '../../components/Input/Input';
import { useDispatch, useSelector } from 'react-redux';
import { getEmployerList } from '../../redux/actions/employer/getEmployerList';
import { getManagerList } from '../../redux/actions/user/getManagerList';
import { createVacancy } from '../../redux/actions/dashborad/createVacancy';
import Loading from '../../components/Loading/Loading';
import { resetCreateVacancy, resetGetVacancySingle, resetUpdateVacancy } from '../../redux/slices/dashboard.slice';
import { getVacancySingle } from '../../redux/actions/dashborad/getVacancySingle';
import { updateVacancy } from '../../redux/actions/dashborad/updateVacancy';
import { toast } from 'react-toastify';
import { useMediaQuery } from '../../utils/useMediaQuery';
import { usePermissions } from '../../hooks/usePermissions';
import AccessDenied from '../../components/AccessDenied/AccessDenied';

function CreateVacancy() {
  let navigate = useNavigate();
  const { pathname } = useLocation();
  const { hasPermission, isLoaded } = usePermissions();
  const isCreateVacancyPage = pathname === '/create';
  const isCreateHrPage = pathname === '/createJob';
  const canOpenCreatePage = (isCreateVacancyPage && hasPermission('add_any_vacancy')) || (isCreateHrPage && hasPermission('add_any_hr'));
  const isMobile = useMediaQuery('(max-width: 700px)');
  const dispatch = useDispatch();
  const {
    createVacancy: { data: createVacancyData, error: createVacancyError, loading: createVacancyLoading },
    getVacancySingle: { data: getVacancySingleData, error: getVacancySingleError, loading: getVacancySingleLoading },
    updateVacancy: { data: updateVacancyData, error: updateVacancyError, loading: updateVacancyLoading },
  } = useSelector((state) => state.dashboard);
  console.log(createVacancyError);

  useEffect(() => {
    if (createVacancyError) {
      const errorData = createVacancyError?.payload?.data?.detail;
      const errorStatus = createVacancyError?.payload?.status;
      if (errorData) {
        toast.error(errorData, { theme: 'colored', autoClose: '3000' });
      } else {
        switch (errorStatus) {
          case 400:
            {
              toast.error('Получены некорректные данные. Проверьте их на наличие ошибок и попробуйте снова.', { theme: 'colored', autoClose: '3000' });
            }
            break;
          case 403:
            {
              toast.error('Нет доступа к запрашиваемому ресурсу.', { theme: 'colored', autoClose: '3000' });
            }
            break;
          case 404:
            {
              toast.error('Запрашиваемый ресурс не найден.', { theme: 'colored', autoClose: '3000' });
            }
            break;
          case 500:
            {
              toast.error('Сервер не смог обработать запрос. Повторите попытку позже.', { theme: 'colored', autoClose: '3000' });
            }
            break;
          default:
            break;
        }
      }
      dispatch(resetCreateVacancy());
    }
  }, [createVacancyError]);

  const isHR = pathname == '/createJob' || getVacancySingleData?.is_hr;
  const handleSave = (data) => {
    console.log(data);

    Swal.fire({
      title: 'Вы уверены что хотите создать вакансию?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        const formatData = { ...data, is_hr: isHR };
        console.log(formatData);

        Object.keys(formatData).map((k) => (formatData[k] ? false : delete formatData[k]));
        formatData.manager_id = formatData.manager_id.value;
        formatData.employer_id = formatData.employer_id.value;
        formatData.sex = formatData.sex == 'null' ? null : formatData.sex == 'true' ? true : false;
        console.log(formatData);
        dispatch(createVacancy(formatData));
      }
    });
  };

  const handleUpdate = (data) => {
    Swal.fire({
      title: 'Вы уверены что хотите отредактировать вакансию?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        const formatData = { ...data, is_hr: isHR };
        // console.log(formatData);
        let dataUpdate = {};
        inputs(isHR)?.map((input) => {
          if (Array.isArray(input)) {
            input?.map((subInput) => {
              let val = data[subInput?.name];
              if (subInput?.name == 'sex') {
                if (val == 'null') {
                  val = null;
                } else if (val == 'true') {
                  val = true;
                } else {
                  val = false;
                }
              }
              dataUpdate = { ...dataUpdate, [subInput?.name]: val };
            });
          } else {
            let val = data[input?.name];
            if (input?.name == 'employer_id' || input?.name == 'manager_id') {
              val = val?.value;
            }

            dataUpdate = { ...dataUpdate, [input?.name]: val };
            // form.setValue(input.name, input.list[0].value);
          }
        });

        console.log('UPDATE', dataUpdate);
        dispatch(updateVacancy({ ...dataUpdate, id }));
        // Object.keys(formatData).map((k) => (formatData[k] ? false : delete formatData[k]));
        // formatData.manager_id = formatData.manager_id.value;
        // formatData.employer_id = formatData.employer_id.value;
        // formatData.sex = formatData.sex == 'null' ? null : formatData.sex == 'true' ? true : false;
        // console.log(formatData);
        // dispatch(createVacancy(formatData));
      }
    });
  };

  const handleCancel = () => {
    Swal.fire({
      title: 'Вы действительно хотите отменить создание вакансии?',
      text: 'Внесенные изменения не сохранятся',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        navigate(-1);
      }
    });
  };
  const inputs = (isHR) => [
    { type: 'text', required: false, label: 'Название организации', name: 'organization_name', placeholder: '' },
    { type: 'text', required: true, label: 'Название вакансии', name: 'name', placeholder: 'Грузчик на склад' },
    { type: 'text', required: true, label: 'Адрес', name: 'location', placeholder: 'г. Краснодар, ул.Красная, 1' },
    {
      type: 'select',
      required: true,
      label: 'Тип вакансии',
      name: 'type',
      list: [
        {
          value: 'permanent',
          label: 'Постоянная работа',
        },
        { value: 'rotational', label: 'Вахта' },
        { value: 'parttime', label: 'Частичная занятость' },
        { value: 'onetime', label: 'Разовая работа' },
      ],
    },
    {
      type: 'textarea',
      required: true,
      label: 'Описание вакансии',
      name: 'description',
      placeholder: 'Выполнение погрузочных работ на складе сборного груза: сбор товара на поддоны, загрузка с использование ручной рохли. Склад с комфортной температурой. Масса грузов не превышает 10 кг. Дневные и ночные смены на выбор. Перерывы каждые 2 часа, полноценный часовой перерыв.',
    },
    {
      type: 'textarea',
      required: true,
      label: 'Требования к соискателю',
      name: 'requirements',
      placeholder: 'Готовы рассмотреть сотрудников без опыта работы. Обязательно наличие медицинской книжки. Гражданство РФ.',
    },
    [
      {
        type: 'select',
        required: true,
        label: 'Пол',
        name: 'sex',
        list: [
          {
            value: 'null',
            label: 'Неважно',
          },
          { value: 'false', label: 'Мужской' },
          { value: 'true', label: 'Женский' },
        ],
      },
      {
        type: 'number',
        required: false,
        label: 'Мин. возраст',
        name: 'min_age',
        placeholder: '18',
      },
      {
        type: 'number',
        required: false,
        label: 'Мин. возраст',
        name: 'max_age',
        placeholder: '65',
      },
    ],
    [
      {
        type: 'select',
        required: true,
        label: 'Периодичность выплат',
        name: 'pay_type',
        list: [
          { value: 'everyday', label: 'Ежедневно' },
          { value: 'everyweek', label: 'Еженедельно' },
          { value: 'everymonth', label: 'Ежемесячно' },
        ],
      },
      {
        type: 'number',
        required: true,
        label: 'Мин стоимость раб.смены',
        name: 'min_shift_cost',
        placeholder: '1000',
      },
      {
        type: 'number',
        required: true,
        label: 'Макс стоимость раб.смены',
        name: 'max_shift_cost',
        placeholder: '10000',
      },
    ],
    [
      {
        type: 'select',
        required: false,
        label: 'Мин. длит. раб. смены',
        name: 'min_work_duration',
        list: [
          { value: '2', label: '2 часа' },
          { value: '3', label: '3 часа' },
          { value: '4', label: '4 часа' },
          { value: '5', label: '5 часов' },
          { value: '6', label: '6 часов' },
          { value: '7', label: '7 часов' },
          { value: '8', label: '8 часов' },
          { value: '9', label: '9 часов' },
          { value: '10', label: '10 часов' },
          { value: '11', label: '11 часов' },
          { value: '12', label: '12 часов' },
          { value: '13', label: '13 часов' },
          { value: '14', label: '14 часов' },
          { value: '15', label: '15 часов' },
          { value: '16', label: '16 часов' },
          { value: '17', label: '17 часов' },
          { value: '18', label: '18 часов' },
          { value: '19', label: '19 часов' },
          { value: '20', label: '20 часов' },
          { value: '21', label: '21 часов' },
          { value: '22', label: '22 часов' },
          { value: '23', label: '23 часов' },
          { value: '24', label: '24 часов' },
        ],
      },
      {
        type: 'select',
        required: false,
        label: 'Макс. длит. раб. смены',
        name: 'max_work_duration',
        list: [
          { value: '24', label: '24 часов ' },
          { value: '23', label: '23 часов' },
          { value: '22', label: '22 часов' },
          { value: '21', label: '21 часов' },
          { value: '20', label: '20 часов' },
          { value: '18', label: '18 часов' },
          { value: '17', label: '17 часов' },
          { value: '16', label: '16 часов' },
          { value: '15', label: '15 часов' },
          { value: '14', label: '14 часов' },
          { value: '13', label: '13 часов' },
          { value: '12', label: '12 часов' },
          { value: '11', label: '11 часов' },
          { value: '10', label: '10 часов' },
          { value: '9', label: '9 часов' },
          { value: '8', label: '8 часов' },
          { value: '7', label: '7 часов' },
          { value: '6', label: '6 часов' },
          { value: '5', label: '5 часов' },
          { value: '4', label: '4 часа' },
          { value: '3', label: '3 часа' },
          { value: '2', label: '2 часа' },
        ],
      },
    ],

    {
      type: 'select',
      required: false,
      label: 'Выбор тарифа',
      name: 'tariff',
      list: isHR
        ? [
            { value: 'hr', label: 'Базовый (1000р.)' },
            { value: 'hr_result', label: 'Базовый + результат (5000р.)' },
            { value: 'hr_guarantee', label: 'Базовый + результат + гарантия (10000р.)' },
          ]
        : [{ value: 'free', label: 'Стартовый (бесплатно)' }],
    },
    {
      type: 'search-select',
      required: false,
      label: 'Контрагент',
      name: 'employer_id',

      onSearch: (searchText, page) => {
        console.log(searchText);

        dispatch(getEmployerList({ name: searchText, page }));
      },
      actionName: 'getEmployerList',
      sliceName: 'employer',
      optionName: 'name',
    },
    {
      type: 'search-select',
      required: false,
      label: 'Менеджер',
      name: 'manager_id',

      onSearch: (searchText, page) => {
        console.log(searchText);

        dispatch(getManagerList({ full_name: searchText, page }));
      },
      actionName: 'getManagerList',
      sliceName: 'user',
      optionName: 'full_name',
    },
  ];
  // const [inputs, setInputs] = useState();
  const form = useForm();
  const { id } = useParams();
  useEffect(() => {
    if (id) {
      dispatch(getVacancySingle(id));
    }
  }, [id]);
  React.useEffect(() => {
    const subscription = form.watch((value, { name, type }) => {
      if (name == 'employer_id' && value?.employer_id) {
        form.setValue('organization_name', value?.employer_id?.label);
      }
    });
    return () => subscription.unsubscribe();
  }, [form.watch]);

  useEffect(() => {
    if (getVacancySingleData) {
      Object.keys(getVacancySingleData)?.map((key) => {
        let value;
        let keyForm = key;
        if (key == 'location') {
          value = getVacancySingleData[key]?.address;
        } else if (key == 'sex') {
          value = getVacancySingleData[key] === null ? 'null' : getVacancySingleData[key];
        } else if (key == 'employer') {
          keyForm = 'employer_id';
          value = { label: getVacancySingleData?.[key]?.name, value: getVacancySingleData?.[key]?.id };
        } else if (key == 'manager') {
          keyForm = 'manager_id';
          value = { label: getVacancySingleData?.[key]?.full_name, value: getVacancySingleData?.[key]?.id };
        } else {
          value = getVacancySingleData[key];
        }

        // const value =  key == 'location' ?  : key == 'sex' && getVacancySingleData[key] === null ? 'null' : getVacancySingleData[key];
        form.setValue(keyForm, value);
      });
    }
  }, [getVacancySingleData]);
  useEffect(() => {
    return () => {
      dispatch(resetGetVacancySingle());
    };
  }, []);

  useEffect(() => {
    if (createVacancyData) {
      Swal.fire({
        icon: 'success',
        title: 'Вакансия успешно создана',
        showConfirmButton: false,
        timer: 1500,
      }).then((result) => {
        dispatch(resetCreateVacancy());
        dispatch(resetGetVacancySingle());
        navigate(-1);
      });
    }
  }, [createVacancyData]);

  useEffect(() => {
    if (updateVacancyData) {
      Swal.fire({
        icon: 'success',
        title: 'Вакансия успешно отредактирована',
        showConfirmButton: false,
        timer: 1500,
      }).then((result) => {
        dispatch(resetUpdateVacancy());
        dispatch(resetGetVacancySingle());
        navigate(`/activation/${id}`);
      });
    }
  }, [updateVacancyData]);

  useEffect(() => {
    inputs(isHR)?.map((input) => {
      if (Array.isArray(input)) {
        input?.map((subInput) => {
          if (subInput.type == 'select') {
            form.setValue(subInput.name, subInput.list[0].value);
          }
        });
      } else {
        if (input.type == 'select') {
          form.setValue(input.name, input.list[0].value);
        }
      }
    });
    form.register('manager_id', { required: { value: true, message: '*Обязательное поле для заполнения' } });
    form.register('employer_id', { required: { value: true, message: '*Обязательное поле для заполнения' } });
  }, []);

  if ((isCreateVacancyPage || isCreateHrPage) && !isLoaded) {
    return (
      <div className="w-full flex flex-1 items-center justify-center mt-10">
        <Loading />
      </div>
    );
  }

  if ((isCreateVacancyPage || isCreateHrPage) && !canOpenCreatePage) {
    return <AccessDenied />;
  }

  return (
    <div className="mx-auto p-2 flex-1 justify-center w-full max-w-3xl">
      <div className="w-full mt-9">
        {/* starting text */}
        <div className="flex flex-col justify-center items-center gap-1">
          <p className="text-2xl font-medium">{pathname == '/createJob' ? 'Создание вакансии поиска и подбора' : id ? 'Редактирование вакансии' : 'Создание вакансии'}</p>
        </div>

        <div className="p-6 mt-4 border-2 border-gray-200 rounded-xl">
          {/* <form> */}

          {inputs(isHR)?.map((input) =>
            Array.isArray(input) ? (
              <div
                className={`w-full mt-6 grid gap-2`}
                style={{
                  gridTemplateColumns: isMobile ? '1fr' : `repeat(${input?.length},1fr)`,
                }}>
                {input?.map((item) => (
                  <Input type={item.type} {...(item?.rules ? { rules: item?.rules } : !item.required ? { rules: { required: false } } : {})} form={form} label={item.label} name={item.name} disabled={createVacancyLoading} format={item?.format} placeholder={item.placeholder} list={item.list} />
                ))}
              </div>
            ) : (
              <Input
                type={input.type}
                {...(input?.rules ? { rules: input?.rules } : !input.required ? { rules: { required: false } } : {})}
                classNameWrap={'mt-3'}
                form={form}
                label={input.label}
                name={input.name}
                disabled={input.name == 'organization_name' || createVacancyLoading}
                format={input?.format}
                placeholder={input.placeholder}
                list={input.list}
                onSearch={input.onSearch}
                actionName={input.actionName}
                sliceName={input.sliceName}
                optionName={input.optionName}
              />
            ),
          )}

          {/* <div className='mb-6'>
                        <label htmlFor='manager' className='block mb-2 text-sm font-bold text-gray-900'>
                            Менеджер 
                        </label>
                        <Select
                            classNames={{
                                menuButton: ({ isDisabled }) => (
                                    `flex justify-between pr-1.5 py-1 shadow-sm text-gray-900 text-sm border border-1 border-gray-300 focus:border-button focus:outline-none ${
                                        isDisabled
                                            ? "bg-gray-200"
                                            : "bg-white hover:border-gray-400 focus:border-blue-500 focus:ring focus:ring-blue-500/20"
                                    }`
                                ),
                                menu: "absolute z-10 w-full bg-white shadow-lg border-1 rounded py-1 mt-1.5 text-sm text-gray-700",
                                listItem: ({ isSelected }) => (
                                    `block transition duration-200 px-2 py-2 cursor-pointer select-none truncate rounded ${
                                        isSelected
                                            ? `text-white bg-blue-500`
                                            : `text-gray-500 hover:bg-blue-100 hover:text-blue-500`
                                    }`
                                ),
                                searchIcon: "hidden ",
                                searchBox: "w-full text-sm text-gray-500 bg-gray-100 border border-gray-200 rounded focus:border-gray-200 focus:ring-0 focus:outline-none",
                            }}
                            placeholder='Название Менеджер'
                            value={managerNameState}
                            onChange={handleManagerChange}
                            options={managerOptions}
                            isSearchable
                            isClearable
                        />
                    </div>

                    <div className='mb-6'>
                        <label htmlFor='add' className='block mb-2 text-sm font-bold text-gray-900'>
                            Контрагент
                        </label>
                        <Select
                            classNames={{
                                menuButton: ({ isDisabled }) => (
                                    `flex justify-between pr-1.5 py-1 shadow-sm text-gray-900 text-sm border border-1 border-gray-300 focus:border-button focus:outline-none ${
                                        isDisabled
                                            ? "bg-gray-200"
                                            : "bg-white hover:border-gray-400 focus:border-blue-500 focus:ring focus:ring-blue-500/20"
                                    }`
                                ),
                                menu: "absolute z-10 w-full bg-white shadow-lg border-1 rounded py-1 mt-1.5 text-sm text-gray-700",
                                listItem: ({ isSelected }) => (
                                    `block transition duration-200 px-2 py-2 cursor-pointer select-none truncate rounded ${
                                        isSelected
                                            ? `text-white bg-blue-500`
                                            : `text-gray-500 hover:bg-blue-100 hover:text-blue-500`
                                    }`
                                ),
                                searchIcon: "hidden ",
                                searchBox: "w-full text-sm text-gray-500 bg-gray-100 border border-gray-200 rounded focus:border-gray-200 focus:ring-0 focus:outline-none",
                            }}
                            placeholder='Название контрагента'
                            value={jobPosterNameState}
                            onChange={handlePosterChange}
                            options={JobPosterOptions}
                            isSearchable
                            isClearable
                        />
                    </div> */}

          <div className="flex flex-col middle:flex-row gap-6 justify-center middle:justify-start items-center mt-10 ">
            <button className="bg-button text-white font-bold py-2 px-4 rounded w-full md:w-auto" onClick={form.handleSubmit(id ? handleUpdate : handleSave)}>
              {id ? 'Сохранить' : 'Создать вакансию'}
            </button>
            <button type="button" className="text-center border rounded py-2 px-4  text-button border-button border-1 w-full md:w-auto hover:text-white bg-white hover:bg-button transition ease-in-out duration-300" onClick={handleCancel}>
              Отмена
            </button>
            {createVacancyLoading && (
              <div className="relative ml-3">
                {' '}
                <Loading />
              </div>
            )}
          </div>
          {/* </form> */}
        </div>
      </div>
    </div>
  );
}

export default CreateVacancy;
